/* eslint-disable max-classes-per-file */
import { formatCurrencyAndTwoDecimalsString } from "../../../../lib/formatter"
import { hyphenSymbol } from "../VariableStatic"
import { person } from "./Static"

export class ConferenceProjectListPresenter {
  constructor(conferenceProject) {
    let limitPeople = hyphenSymbol
    if (conferenceProject.limit) {
      if (
        conferenceProject.limit.from
        && conferenceProject.limit.to
      ) {
        limitPeople = `${conferenceProject.limit.from} - ${conferenceProject.limit.to}`
      } else if (conferenceProject.limit.from) {
        limitPeople = conferenceProject.limit.from
      }
    }

    const pricePackPerUnitText = conferenceProject.price_package_per_unit || ''
    const pricePackagePerUnitText = `${formatCurrencyAndTwoDecimalsString(
      pricePackPerUnitText, 2, '฿'
    )}/${person}`

    this.conferenceId = conferenceProject.id
    this.title = conferenceProject.title || hyphenSymbol
    this.detail = conferenceProject.detail || hyphenSymbol
    this.image = conferenceProject.images && conferenceProject.images.length > 0
      ? conferenceProject.images[0]
      : ''
    this.limit = `${limitPeople} ${person}`
    this.address = conferenceProject.address || ''
    this.conferencePrice = formatCurrencyAndTwoDecimalsString(
      conferenceProject.price, 2, '฿'
    ) || ''
    this.conferencePricePackagePerUnit = pricePackagePerUnitText
  }
}

export class ConferenceProjectTitleListPresenter {
  constructor(conferenceProjectTitle) {
    this.id = conferenceProjectTitle.id
    this.title = conferenceProjectTitle.title
  }
}
